module.exports = __webpack_public_path__ + "media/src/components/shared/general/img/dummyUserImg-00d4ecf9269ee48fd056e18a90a14928.png";